import React, {ReactElement} from 'react';
import cn from 'classnames';

import s from './checkoutSkeleton.scss';

type PlaceholderPropsType = {
    className?: string;
};
const Placeholder = ({className}: PlaceholderPropsType) => {
    return <div className={cn(className, s.placeholder)} />;
};
Placeholder.defaultProps = {
    className: null,
};

/**
 * Skeleton for checkout page
 * @returns {React.ReactNode} jsx
 */
export const CheckoutSkeleton = (): ReactElement => {
    return (
        <div>
            <div className={s.progressBar}>
                <Placeholder />
                <Placeholder />
                <Placeholder />
                <Placeholder className={s.line} />
            </div>

            <div className={cn(s.guestBlock, s.container)}>
                <Placeholder className={s.guestBlock__title} />
                <Placeholder className={s.guestBlock__subtitle} />
            </div>
            <div className={cn(s.form, s.container)}>
                <Placeholder className={s.stepTitle} />
                <Placeholder className={s.fields} />
                <Placeholder className={s.shippingMethod} />
                <Placeholder className={s.continue} />

                <div className={s.step} />
                <div className={s.step} />
            </div>
        </div>
    );
};
